import {APP_STORE_URL, PLAY_STORE_URL} from '../../constants';
import posthog, {isPostHogConfigured} from '../../posthog';

// Official-style store badges: brand logo + store name, stacked vertically.

const badgeStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  width: '100%',
  maxWidth: 260,
  padding: '12px 20px',
  borderRadius: 14,
  border: '1px solid var(--color-border)',
  background: 'var(--color-surface-elevated)',
  color: 'var(--color-text-primary)',
  textDecoration: 'none',
  transition: 'filter 0.15s, transform 0.1s',
};

const nameStyle: React.CSSProperties = {
  fontSize: 17,
  fontWeight: 700,
  lineHeight: 1.2,
};

function AppleLogo() {
  return (
    <svg width="26" height="26" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="currentColor"
        d="M16.7 12.9c0-2.2 1.8-3.3 1.9-3.3-1-1.5-2.6-1.7-3.2-1.7-1.4-.1-2.7.8-3.4.8-.7 0-1.8-.8-2.9-.8-1.5 0-2.9.9-3.7 2.2-1.6 2.7-.4 6.8 1.1 9 .7 1.1 1.6 2.3 2.8 2.2 1.1 0 1.5-.7 2.9-.7s1.7.7 2.9.7c1.2 0 2-1.1 2.7-2.2.9-1.2 1.2-2.4 1.2-2.5 0 0-2.3-.9-2.3-3.7zM14.5 5.9c.6-.8 1-1.8.9-2.9-.9 0-2 .6-2.6 1.4-.6.7-1.1 1.8-.9 2.8 1 .1 2-.5 2.6-1.3z"
      />
    </svg>
  );
}

function PlayLogo() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
      <path
        fill="#00A0FF"
        d="M3.6 1.7 13.7 11.8 3.6 21.9c-.4-.2-.6-.6-.6-1.1V2.8c0-.5.2-.9.6-1.1Z"
      />
      <path
        fill="#00D781"
        d="M17.3 8.2 13.7 11.8 3.6 1.7c.4-.2.9-.2 1.4.1l12.3 6.4Z"
      />
      <path
        fill="#FF3A44"
        d="M17.3 15.4 5 21.8c-.5.3-1 .3-1.4.1l10.1-10.1 3.6 3.6Z"
      />
      <path
        fill="#FFCE00"
        d="m17.3 8.2 3.7 2c.9.5.9 2.7 0 3.2l-3.7 2-3.6-3.6 3.6-3.6Z"
      />
    </svg>
  );
}

const hover = {
  onMouseEnter: (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.filter = 'brightness(1.12)';
    e.currentTarget.style.transform = 'translateY(-1px)';
  },
  onMouseLeave: (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.currentTarget.style.filter = '';
    e.currentTarget.style.transform = '';
  },
};

export function StoreBadges({placement}: {placement: string}) {
  const track = (store: 'app_store' | 'google_play') => {
    if (isPostHogConfigured) {
      posthog.capture('store_badge_clicked', {store, placement});
    }
  };
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 10,
        width: '100%',
      }}
    >
      <a
        href={APP_STORE_URL}
        onClick={() => track('app_store')}
        target="_blank"
        rel="noreferrer"
        style={badgeStyle}
        {...hover}
      >
        <AppleLogo />
        <span style={nameStyle}>App Store</span>
      </a>
      <a
        href={PLAY_STORE_URL}
        onClick={() => track('google_play')}
        target="_blank"
        rel="noreferrer"
        style={badgeStyle}
        {...hover}
      >
        <PlayLogo />
        <span style={nameStyle}>Google Play</span>
      </a>
    </div>
  );
}
